import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-aviso-legal',
  templateUrl: './politica-cookies.component.html',
  styleUrls: ['./politica-cookies.component.scss']
})
export class PoliticaCookiesComponent implements OnInit {

  constructor(private location: Location) { }

  ngOnInit(): void {
  }

  irAUrlAnterior() {
    this.location.back();
  }

}
